export default function (callbackMethodName) {
  return {
    mounted () {
      const urlParameters = new URLSearchParams(window.location.search)
      const token = urlParameters.get('id')
      const resourcePath = urlParameters.get('resourcePath')
      if (token !== null && resourcePath !== null) {
        this[callbackMethodName](token, true)
      }
      window.addEventListener('message', this.receiveMessage, false)
      window.addEventListener('oppwaError', this.onError, false)
    },
    beforeDestroy () {
      window.removeEventListener('message', this.receiveMessage)
      window.removeEventListener('oppwaError', this.onError)
    },
    methods: {
      stripUrl () {
        window.history.replaceState({}, document.title, window.location.pathname)
      },
      receiveMessage (event) {
        const data = event.data
        const comp = this
        if (data.method === 'asyncRedirect' && data.params) {
          const param = data.params.find(item => item.name === 'id')
          if (param && param.value) {
            comp[callbackMethodName](param.value, false)
          }
        }
      },
      onError (error) {
        console.log(error)
      }
    }
  }
}
